"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.companySegmentArray = exports.companySegments = exports.companyStatuses = void 0;
exports.companyStatuses = {
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    IDLE: 'IDLE',
    SUSPENDED: 'SUSPENDED',
};
exports.companySegments = {
    PROCESSOR: 'PROCESSOR',
    FARMER: 'FARMER',
    EXPORTER: 'EXPORTER',
    RETAIL: 'RETAIL',
    WHOLESALER: 'WHOLESALER',
    TRADER: 'TRADER',
    DISTRIBUTOR: 'DISTRIBUTOR',
    FOOD_SERVICE_CHAIN: 'FOOD_SERVICE_CHAIN',
    FOOD_SERVICE_DISTRIBUTOR: 'FOOD_SERVICE_DISTRIBUTOR',
    IMPORTER: 'IMPORTER',
    SEAFOOD_MARKETPLACE: 'SEAFOOD_MARKETPLACE',
};
exports.companySegmentArray = [
    {
        id: exports.companySegments.PROCESSOR,
        description: 'Processor',
    },
    {
        id: exports.companySegments.FARMER,
        description: 'Farmer',
    },
    {
        id: exports.companySegments.EXPORTER,
        description: 'Exporter',
    },
    {
        id: exports.companySegments.RETAIL,
        description: 'Retailer',
    },
    {
        id: exports.companySegments.WHOLESALER,
        description: 'Wholesaler',
    },
    {
        id: exports.companySegments.TRADER,
        description: 'Trader',
    },
    {
        id: exports.companySegments.DISTRIBUTOR,
        description: 'Distributor',
    },
    {
        id: exports.companySegments.FOOD_SERVICE_CHAIN,
        description: 'Food Service Chain/Outlet',
    },
    {
        id: exports.companySegments.FOOD_SERVICE_DISTRIBUTOR,
        description: 'Food Service Distributor',
    },
    {
        id: exports.companySegments.IMPORTER,
        description: 'Importer',
    },
    {
        id: exports.companySegments.SEAFOOD_MARKETPLACE,
        description: 'Seafood Marketplace',
    },
];
